import React, {useState, useEffect} from "react";


import {
    Box,
    Button,
    IconButton,
    InputAdornment,
    LinearProgress,
    TextField,
    Theme,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    Slide,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MonitorIcon from '@mui/icons-material/Monitor';
import {ContainerClasses} from '../../themes/containerClasses'
import {useAuth} from "../../hooks/useAuth";
import {useSnackbar} from "notistack";

export const MFAChallengeDialog: React.FC<{
  username: string,
  password: string
}> = ({
  username,
  password
}) => {

  const styles = ContainerClasses();

  const {error, mfaChallenge, onMfaChallenge, isLoading} = useAuth();
  const { enqueueSnackbar } = useSnackbar();

  const [otp, setOtp] = useState<string>("");


  useEffect(() => {
    if(error.errorMfaChallenge !== ""){
         enqueueSnackbar(error.errorMfaChallenge, {
          variant: "error",
        });
      }
  }, [error]);


  const onSubmitMfaOtp = () => {
    onMfaChallenge(otp, username, password)
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    onSubmitMfaOtp()
  }

  return (

    <Dialog
          open={mfaChallenge}
          onClose={() => {}}
          maxWidth={"lg"}
          fullWidth
          TransitionComponent={Slide}
          TransitionProps={{direction: "up"} as any}
    >

       <DialogTitle>
          {isLoading && <LinearProgress color="primary" />}
         <Box sx={{mt: '4pt',
                   mb: '4pt'}}>
           <Typography
               color="textSecondary"
               align="center"
             >
               Please provide your MFA code
             </Typography>
          </Box>
       </DialogTitle>

      <Box sx={{
        marginTop: "20px",
        marginLeft: "10px",
        marginRight: "10px",
        marginBottom: "10px"
      }}>

       <form onSubmit={handleSubmit}>

         <Box sx={{
             display: "flex",
             flexDirection: "column",
             justifyContent: "center",
             marginTop: "10px",
             marginBottom: "10px",
             width: '100%'}}>

            <TextField
               error={false}
               disabled={isLoading}
               size="small"
               label={"Code"}
               variant="filled"
               value={otp}
               onChange={(event) => setOtp(event.target.value)}
            />
         </Box>

         <Box sx={styles.containerRowB}>
           <Button
              color="primary"
              variant="contained"
              fullWidth
              disabled={isLoading}
              type="submit"
           >
             Verify
           </Button>
         </Box>

       </form>

    </Box>

  </Dialog>


  );

};
